// src/pages/products/ProductsLayout.jsx
import { Outlet, NavLink } from 'react-router-dom';
import { AppSidebar } from '../../components/AppSidebar/AppSidebar';
import '../settings/settings.scss';

export default function ProductsLayout() {
  return (
    <div className="layout">
      <AppSidebar />
      <div className="layout__content">
        <header className="settings-header">
          <h1 className="settings-header__title">Products</h1>
          <p className="settings-header__subtitle">Manage your product catalog and pricing</p>
        </header>

        <nav className="settings-tabs" role="tablist" aria-label="Products Tabs">
          <NavLink
            to="/products"
            end
            className={({ isActive }) => `settings-tabs__item ${isActive ? 'is-active' : ''}`}
          >
            List
          </NavLink>
          <NavLink
            to="/products/new"
            className={({ isActive }) => `settings-tabs__item ${isActive ? 'is-active' : ''}`}
          >
            Create
          </NavLink>
        </nav>

        <section className="settings-body">
          <Outlet />
        </section>
      </div>
    </div>
  );
}
